import { Component, computed, input } from '@angular/core';
import { AssetDetail } from '../../services/asset-service/types';

@Component({
  selector: 'asset-detail-sidebar',
  templateUrl: './asset-detail-sidebar.html',
  styleUrl: './asset-detail-sidebar.scss',
})
export class AssetDetailSidebar {
  asset = input.required<AssetDetail>();

  geographicalCoverageData = computed(() => {
    if (this.asset().regions.length === 0) {
      return undefined;
    }
    return this.asset().regions;
  });
}
